// This is a generated file. Any changes made directly in this file will be overwritten.
import * as React from 'react';
import { createSvgIcon } from '@bb-ui/react-library/dist/internal/icons';

export const Soccer = createSvgIcon(
  { All: <React.Fragment><g stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="11" /><path d="M8.3985 10.4863l3.6002-2.2987 3.5755 2.2986-1.0956 4.3033H9.5182l-1.1197-4.3032zM12 8.2106V3.1579M8.8419 10.7372l-4.421-1.895M15.7895 10.7369l3.7894-1.8948M14.5264 14.5263l2.5263 3.7895M21 18l-3.9473.3158L15 22.5M9.4736 14.5263l-2.5263 3.7895M3 18l3.9473.3158L9 22.5M23 10.5l-3.4211-1.6579L20 4.5M1 10.5l3.421-1.6579L4 4M7.579 1.579L12 3.7895l4.4211-2.2105" /></g><defs></defs></React.Fragment>, },
  'default'
);
